module.exports = __webpack_public_path__ + "img/product_03_pic@2x.8d25cfe2.png";